import { render, staticRenderFns } from "./StaffBindSuccess.vue?vue&type=template&id=3d5c5a17&"
import script from "./StaffBindSuccess.vue?vue&type=script&lang=js&"
export * from "./StaffBindSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports